import {
  PageHeader,
  PageHeaderBreadcrumb,
  PageHeaderBreadcrumbLink,
  PageHeaderBreadcrumbPage,
  PageHeaderIdentity,
} from '@/shared/ui/layout/PageHeader';
import type { BreadcrumbPageHeaderProps } from './BreadcrumbPageHeader.types';

/**
 * Breadcrumb-only page header for a shell whose title, description, and
 * actions live in a per-record identity block instead of the header itself.
 * Copy is fully resolved by the caller so this component carries no i18n key.
 */
export function BreadcrumbPageHeader({ trail, page, info }: BreadcrumbPageHeaderProps) {
  return (
    <PageHeader>
      <PageHeaderIdentity>
        <PageHeaderBreadcrumb info={info ? { page, onClick: info.onClick } : undefined}>
          {trail.map((crumb) => (
            <PageHeaderBreadcrumbLink key={crumb.href} href={crumb.href}>
              {crumb.label}
            </PageHeaderBreadcrumbLink>
          ))}
          <PageHeaderBreadcrumbPage>{page}</PageHeaderBreadcrumbPage>
        </PageHeaderBreadcrumb>
      </PageHeaderIdentity>
    </PageHeader>
  );
}

BreadcrumbPageHeader.displayName = 'BreadcrumbPageHeader';
